"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WalletBalance = /** @class */ (function () {
    function WalletBalance() {
    }
    return WalletBalance;
}());
exports.WalletBalance = WalletBalance;
//# sourceMappingURL=WalletBalance.js.map